import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addToWhishlistService } from "../services/addToWishlistservices";

// Async thunk for adding a product to the wishlist
export const addToWhishlist = createAsyncThunk(
  "wishlist/addToWhishlist",
  async (product_id, { getState, rejectWithValue }) => {
    const state = getState();
    const token = state.auth.api_token; // Get token from the auth state (you can modify according to your structure)

    if (token) {
      try {
        const response = await addToWhishlistService(product_id); // Call the service function to add the product to wishlist

        return response; // Return the response (it should contain the updated list of liked items)
      } catch (error) {
        console.error("Failed to add to wishlist", error);
        return rejectWithValue(
          error.response?.data || "Failed to add product to wishlist"
        );
      }
    } else {
      // Handle localStorage as a fallback when the user is not logged in
      let likedItems = [];
      try {
        likedItems = JSON.parse(localStorage.getItem("likedItems")) || [];
      } catch (error) {
        console.error("Error reading liked items from localStorage", error);
        likedItems = []; // Default to an empty array if there's an error
      }

      // Check if the product is already in the liked items
      if (!likedItems.includes(product_id)) {
        likedItems.push(product_id); // Add the product to the liked items if it's not already there
        localStorage.setItem("likedItems", JSON.stringify(likedItems)); // Save updated liked items to localStorage
      }

      return { likedItems }; // Return the updated liked items
    }
  }
);

const addToWishlistSlice = createSlice({
  name: "wishlist",
  initialState: {
    likedItems: [], // Start with an empty liked items array
    loading: false,
    error: null,
  },
  reducers: {
    // Action to load wishlist from localStorage if the user is not logged in
    loadWishlistFromLocalStorage: (state) => {
      const storedLikedItems =
        JSON.parse(localStorage.getItem("likedItems")) || [];
      state.likedItems = storedLikedItems;
    },
    // Action to clear the wishlist
    clearWishlist: (state) => {
      localStorage.removeItem("likedItems");
      state.likedItems = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addToWhishlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addToWhishlist.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload && action.payload.likedItems) {
          // If response contains the entire updated likedItems list (logged-in user)
          state.likedItems = action.payload.likedItems; // Replace the list with the new one
        } else if (action.payload) {
          // If response contains a single item (logged-in user with a single added product)
          state.likedItems.push(action.payload); // Add the new item to the wishlist
        }
      })
      .addCase(addToWhishlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { loadWishlistFromLocalStorage, clearWishlist } =
  addToWishlistSlice.actions;

export default addToWishlistSlice.reducer;
